import * as React from 'react';

import { ItemsProvider, useItemsProviderContext } from '@common/react/components/Core/ItemsProvider/ItemsProvider';
import Loader from '@common/react/components/Core/LoadingProvider/Loader';

import { CardImageType } from '@app/objects/CardImageType';
import { CardBlock } from '@app/components/Pages/Register/CardBlock';
import { DrivingLicense } from '@app/objects/DrivingLicense';

interface ComponentProps {
	cardPanelClassName?: string;
}

interface DriverLicenseCardsWrapperProps extends ComponentProps {
	initialItems?: Array<DrivingLicense>;
}

export const DriverLicenseCards: React.FC<ComponentProps> = (props) => {
	const context = useItemsProviderContext<DrivingLicense>();

	if (!context.state) throw 'Need ItemsProvider context!';

	const { state: { items, loading } } = context;

	const drivingLicense: DrivingLicense | undefined = items?.length ? items[0] : undefined;

	return <>
		<div className={`row card-panel${props.cardPanelClassName && ` ${props.cardPanelClassName}`}`}>
			{loading ? <Loader />
				: <>
					<CardBlock
						objectId={drivingLicense ? drivingLicense.id : -1}
						fileType="drivingLicense"
						cardType={CardImageType.Front}
						defaultScr={drivingLicense ? drivingLicense.photoFront : ''}
					/>
					<CardBlock
						objectId={drivingLicense ? drivingLicense.id : -1}
						fileType="drivingLicense"
						cardType={CardImageType.Back}
						defaultScr={drivingLicense ? drivingLicense.photoBack : ''}
					/>
				</>
			}
		</div>
	</>;
};

const DriverLicenseCardsWrapper: React.FC<DriverLicenseCardsWrapperProps> = (props) => {
	return (
		<ItemsProvider<DrivingLicense>
			type="drivingLicense"
			loadRequest="drivingLicensePageViewList"
			items={props.initialItems}
			skipInitLoad={!!props.initialItems}
		>
			<DriverLicenseCards {...props} />
		</ItemsProvider>
	);
};

export default DriverLicenseCardsWrapper;
